export default __webpack_public_path__ + "static/media/p1.0d52302d.jpeg";